import CourseIcon from "../../assets/icons/CourseIcon";
import DashboardIcon from "../../assets/icons/DashboardIcon";
import DiscountIcon from "../../assets/icons/DiscountIcon";
import ProfileIcon from "../../assets/icons/ProfileIcon";
import ReviewIcon from "../../assets/icons/ReviewIcon";
import WishListIcon from "../../assets/icons/WishListIcon";

// sidebar menu list
export const sidebarItems = [
  { path: "dashboard", label: "ড্যাশবোর্ড", icon: DashboardIcon },
  { path: "profile", label: "আমার প্রোফাইল", icon: ProfileIcon },
  { path: "discount", label: "ডিসকাউন্ট", icon: DiscountIcon },
  { path: "courses", label: "কোর্স সমূহ", icon: CourseIcon },
  { path: "wish-list", label: "পছন্দের কোর্স তালিকা", icon: WishListIcon },
  { path: "reviews", label: "রিভিউ সমূহ", icon: ReviewIcon },
] as const;
